import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { GlobalContext } from '../contexts/GlobalContext';
import './UserInfo.css';

function UserInfo() {
    const { isLoggedIn, userLevel } = useContext(GlobalContext);

    return (
        isLoggedIn && (
            <div className="user-dropdown">
                <button className="user-button">
                    <FontAwesomeIcon icon={faUser} />
                </button>
                <div className="dropdown-content">
                    <Link to="/profile">個人資料</Link>
                    <Link to="/logout">登出</Link>
                </div>
            </div>
        )
    );
}

export default UserInfo;
